import { CloudCheckVariantIcon } from './CloudCheckVariantIcon';

/**
 * author: Google
 * id 5B607B90-B492-43AD-A5B0-4AC800A9F7DA
 * name cloud-check-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-check-variant.svg
 * tags
 * - Cloud 
 * - Weather 
 */
export const CloudTickIcon = CloudCheckVariantIcon;
export default CloudTickIcon